import React from 'react'
import AdminLogin from '../../Components/admin/Login'
function Login() {
  return (
    <div>
      <AdminLogin/>
    </div>
  )
}

export default Login
